var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoBbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 228C59.0457 228 68 219.046 68 208V138C68 132.477 80.4772 120 86 120H156C167.046 120 176 111.046 176 100V88C176 76.9543 167.046 68 156 68H86C47.3401 68 16 99.3401 16 138V208C16 219.046 24.9543 228 36 228H48Z",
    fill: "#062134"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M496 138C496 99.3401 464.66 68 426 68H356C344.954 68 336 76.9543 336 88V100C336 111.046 344.954 120 356 120H426C431.523 120 444 132.477 444 138V208C444 219.046 452.954 228 464 228H476C487.046 228 496 219.046 496 208V138Z",
    fill: "#062134"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48 285C59.0457 285 68 293.954 68 305V375C68 380.523 80.4772 393 86 393H156C167.046 393 176 401.954 176 413V425C176 436.046 167.046 445 156 445H86C47.3401 445 16 413.66 16 375V305C16 293.954 24.9543 285 36 285H48Z",
    fill: "#062134"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M496 375C496 413.66 464.66 445 426 445H356C344.954 445 336 436.046 336 425V413C336 401.954 344.954 393 356 393H426C431.523 393 444 380.523 444 375V305C444 293.954 452.954 285 464 285H476C487.046 285 496 293.954 496 305V375Z",
    fill: "#062134"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoBbox);
export default __webpack_public_path__ + "static/media/ico_bbox.75c5804a1ab13873f1ce9c3cf656da15.svg";
export { ForwardRef as ReactComponent };